module.exports = __webpack_public_path__ + "static/media/BO.feb8b3df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/BO.svg
// module id = 2117
// module chunks = 7